import React from 'react';
import PropTypes from 'prop-types';

import { Container, Typography, Button } from '@material-ui/core';

const LoanContent = ({ onSetDrawer, img, children, handler, title }) => {
  const onCloseHandler = () => {
    onSetDrawer('');
  };

  return (
    <>
      <Container style={{ paddingBottom: '1rem' }}>
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '8px'
          }}
        >
          <img alt="line" src="/images/assets/line.svg" />
        </span>
        <span
          onClick={onCloseHandler}
          style={{ position: 'absolute', right: '8px', top: '8px' }}
        >
          <img alt="close-icon" src="/images/assets/close.svg" />
        </span>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '1rem'
          }}
        >
          <span style={{ marginBottom: '1rem' }}>
            <img alt="logo" src={img} />
            <Typography align="center" color="primary" variant="subtitle1">
              {title}
            </Typography>
          </span>
          <span>
            <ul
              style={{
                maxWidth: '400px',
                margin: '0',
                listStyleType: 'none',
                fontFamily: 'sans-serif'
              }}
            >
              {children}
            </ul>
          </span>
        </div>
        <Container>
          <Button
            color="secondary"
            fullWidth
            onClick={() => {
              handler && handler();
            }}
            variant="contained"
          >
            Ajukan Pinjaman Pinang
          </Button>
        </Container>
      </Container>
    </>
  );
};

LoanContent.propTypes = {
  children: PropTypes.node,
  handler: PropTypes.func,
  img: PropTypes.string,
  onSetDrawer: PropTypes.func
};

export default LoanContent;
